import CalendarDatesColor from './CalendarDatesColour.svg';
import CalendarDatesDark from './CalendarDatesDark.svg';
import CalendarDatesLight from './CalendarDatesLight.svg';
export const calendarDates = { color: CalendarDatesColor, dark: CalendarDatesDark, light: CalendarDatesLight };
//# sourceMappingURL=index.js.map